$(document).ready(function(){
  var select_value ="";
  var variants;
  var href = $("#product-handle").attr("href");
  if(href==undefined) return;
  jQuery.getJSON(href + '.js', function(product) {
    console.log(product);
    variants = product.variants;
    for(variant in product.variants){
      select_value += "<option id=" + variants[variant].id + " value='" + variants[variant].id + "'>" + variants[variant].option1 + "</option>";
    }
    $("#select_value").html(select_value);
    update();
  });

  $("#select_value" ).change(function() {
    update();
  });

  function update() {
    var variant;
    var key = $("#select_value" ).children(":selected").attr("id");
    for(var i=0; i<variants.length; i++){
      if(variants[i].id == key){
        variant = variants[i];
        $("#precious_stone").val(variants[i].options[2]);
        $("#grams").val(variants[i].weight);
        $("#product_price_label").text("$" + variants[i].price);
        var id = variants[i].id;
        $("#ProductSelect-product-template option").attr("selected",false);
        $("#ProductSelect-product-template option[value='" + id + "']").attr("selected",true);
      }
    }
  }

});

